import { FunctionComponent } from 'react';
import { useTranslation } from 'react-i18next';
import { useColor } from '@hub/hooks';
import {
  Card,
  Col,
  Flex,
  ProgressSlider,
  Row,
  TextComponent,
} from '@monorepo/react-components';
import { useResponsiveness } from '@monorepo/react-hooks';
import { IconsNames } from '@monorepo/types';
import { ThemeColors } from '@monorepo/types';
import DashboardTooltip from '../../../dashboard-common/dashboard-tooltip/dashboard-tooltip';
import { InactiveDayCardProps } from '../../cards-wrapper/inactive-days';
import { AccountRulesCardIcon } from '../account-rules-icon/account-rules-icon';

const InactiveDaysRule: FunctionComponent<InactiveDayCardProps> = ({
  inactivityDays,
  maxInactiveDays,
  tooltipText,
  isLoading,
}) => {
  const { isMobile } = useResponsiveness();
  const { getColor } = useColor();
  const { t } = useTranslation(['dashboardTemplates']);

  const colorLink = getColor(ThemeColors.colorLink);
  const colorError = getColor(ThemeColors.colorError);

  const violated = inactivityDays >= maxInactiveDays;

  const trackColor = violated ? ThemeColors.colorError : ThemeColors.colorLink;

  return (
    <Card hoverable={false} dashed error={violated} className={'account-rules'}>
      <Row gutter={[5, 10]}>
        <DashboardTooltip tooltipText={tooltipText} />
        <Col span={8} sm={24}>
          <Row
            gutter={[0, 15]}
            justify={'space-between'}
            className={'account-rules__header'}
          >
            <Col span={18}>
              <Flex gap={5} align={'center'}>
                {!isMobile && (
                  <AccountRulesCardIcon
                    violated={violated}
                    iconName={IconsNames.Plug}
                  />
                )}

                <TextComponent
                  responsive={false}
                  color={colorLink}
                  weight={600}
                >
                  {t('dashboardTemplates:inactive_days')}
                </TextComponent>
              </Flex>
            </Col>
          </Row>
        </Col>

        <Col span={16} sm={24}>
          <Flex
            justify={'end'}
            vertical
            className={'account-rules__slider-section'}
          >
            <Flex>
              <TextComponent
                loading={isLoading}
                weight={600}
                color={violated ? colorError : undefined}
                level={3}
              >
                {inactivityDays}/
              </TextComponent>
              <TextComponent loading={isLoading} level={3}>
                {maxInactiveDays}
              </TextComponent>
            </Flex>

            <ProgressSlider
              disabled
              value={inactivityDays}
              trackColor={trackColor}
              max={maxInactiveDays}
            />
          </Flex>
        </Col>
      </Row>
    </Card>
  );
};

export default InactiveDaysRule;
